<template>
	<div>
		<!-- 公用头部 -->
		<div class="new-header">
			<div class="h_top">
				<div class="new-center">
					<span class="guide">欢迎访问单仁牛商-自助MTP转化平台</span>
					<div class="sigin-info-login" v-if="userInfo">
						<em class="sigin-info-txt" @click="memberFn">进入管理</em>
						<figure v-if="userInfo.icon">
							<img :src="userInfo.icon" />
						</figure>
						<figure v-if="!userInfo.icon">
							<img src="../../assets/images/photo-img.png" />
						</figure>
						<span class="sigin-info-login-mobile">
							<span class="cur">{{userInfo.moblie}}</span>
						</span>

						<button class="sigin-info-login-quit" @click="logoutFn">退出</button>
					</div>
					<div class="sigin-info" v-if="!userInfo">
						<button class="sigin-info-btn" @click="memberFn">登录</button>
						<button class="sigin-info-btn" @click="switchLogin('register')">注册</button>
					</div>
				</div>
			</div>
			<div class="new-center">
				<div class="h_con">
					<h1>
						<a href="/">
							<img title="站神平台" class="head-logo" src="../../assets/images/logo2.png" />
						</a>
					</h1>
					<div class="h-txt">
						<p>全网营销“智慧+工具”系统解决方案</p>助力企业数字化经营转型
					</div>
					<div class="h_nav">
						<ul>
							<li>
								<a href="/index.html">首页</a>
							</li>
							<li>
								<a href="/offline.html">大额交易解决方案</a>
							</li>
							<li>
								<a href="/online.html">移动电商解决方案</a>
							</li>
							<li>
								<a href="/marketing.html">视频营销型网站</a>
							</li>
							<li :class="($route.name ==='pageList' || $route.name ==='pageListOld' || $route.name ==='leaflet') && 'cur'">

								<a @click="goPageList" title="网站方案">{{pageRouteName}}</a>
							</li>
							<li :class="($route.name ==='certificate') && 'cur'">
								<router-link :to="{name:'certificate'}" title="SSL证书">SSL证书</router-link>
							</li>
							<li :class="($route.name ==='zcool' || $route.name ==='pic-record') && 'cur'">
								<router-link :to="{name:'zcool'}" title="牛商图库">牛商图库</router-link>
							</li>

							<li>
								<a href="/about.html">关于我们</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<yq-dialog-hint :showDialog.sync="showDialog" :config="dialogConfig" @defined="definedBack"></yq-dialog-hint>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import mixinDialog from '@/mixins/mixinsDialog'

export default {
	data () {
		return {
			pageRouteName: '网站方案'
		}
	},
	mixins: [mixinDialog],
	computed: {
		...mapGetters('user', ['userInfo']),
		...mapGetters('templateConfig', ['filterCombo']),
	},
	created () {
		this.getFrontUserInfo()
		//url判断是否直接进入会员系统
		this.urlVariable()
		let { name } = this.$route
		if (name === 'leaflet') {
			this.pageRouteName = '落地页市场'
		} else {
			this.pageRouteName = '网站方案'
		}
	},
	methods: {
		...mapActions('user', ['logoutUser', 'getFrontUserInfo']),
		//注销
		logoutFn () {
			this.openErrDialog('ask', '操作信息提示', 'logoutUser', '', '确认要退出系统吗？', '确定')
		},
		//未登录
		memberFn () {
			if (this.userInfo) {
				this.$router.push({
					name: 'console'
				})
			} else {
				this.$router.push({ name: 'login' })
			}
		},
		//url判断是否跳转会员
		urlVariable () {
			let url = window.location.hash
			if (url.indexOf('goSiteList') != -1) {
				this.memberFn()
			}
		},
		switchLogin (name) {
			this.$router.push({ name: 'login', query: { showLogin: name } })
		},
		goPageList () {
			let { name } = this.$route
			this.$router.push({ name: 'pageList' })
		}

	}
}

</script>

<style lang="scss" scoped>
/*头部*/
.new-header {
	height: 136px;
	.new-center {
		width: 1300px;
		margin: 0 auto;
	}
}

.h_top {
	height: 36px;
	background: #111;
}

.h_top .guide {
	float: left;
	font-size: 12px;
	color: #a6a6a6;
	padding-right: 18px;
	height: 36px;
	line-height: 36px;
	position: relative;
}

.sigin-info {
	float: right;
	padding: 6px 0 0;
	height: 24px;
}
.sigin-info-login {
	float: right;
	color: #999;
	line-height: 36px;
	height: 36px;
	.sigin-info-txt {
		display: inline-block;
		padding: 0 14px;
		height: 24px;
		border-radius: 11px;
		border: 1px solid #6b6b6b;
		margin-right: 10px;
		font-size: 12px;
		line-height: 21px;
		color: #a6a6a6;
		background: none;
		outline: 0;
		cursor: pointer;
		vertical-align: top;
		margin-top: 6px;
	}
	figure {
		display: inline-block;
		margin-right: 10px;
		img {
			width: 24px;
			height: 24px;
			vertical-align: top;
			margin-top: 6px;
		}
	}
	.sigin-info-login-quit {
		background: none;
		border: 0;
		color: #999;
		margin-left: 20px;
	}
}

.sigin-info .sigin-info-btn {
	float: left;
	width: 70px;
	height: 22px;
	border-radius: 11px;
	border: 1px solid #6b6b6b;
	margin-left: 10px;
	font-size: 14px;
	color: #a6a6a6;
	background: none;
	outline: 0;
	cursor: pointer;
}

.h_con {
	height: 100px;
	position: relative;
}

.h_con h1 {
	float: left;
	margin: 24px 0 0;
}
.head-logo {
	width: 130px;
	a{display: block;}
}
.h-txt {
	float: left;
	margin-top: 30px;
	font-weight: normal;
	font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
	margin-left: 20px;
	font-size: 14px;
	color: #333;
	line-height: 20px;
}
.h-txt p {
	height: 30px;
	font-size: 20px;
	font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
	font-weight: bold;
	color: #ef8201;
	line-height: 30px;
}
.h_nav {
	float: right;
	width: 833px;
	height: 100px;
}

.h_nav li {
	float: left;
	font-size: 16px;
	height: 100px;
	line-height: 100px;
	margin: 0 11px;
}
.h_nav li:last-child {
	margin-right: 0;
}

.h_nav li a {
	display: block;
	color: #333;
}

.h_nav li:hover a,
.h_nav li.cur a {
	color: #f08300;
	font-weight: bold;
}

.logo-head {
	position: absolute;
	top: 50%;
	margin-top: -37px;
	left: 140px;
}
</style>
